import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useCachedFetch } from '@/composables/useFetch';
import { useSessionStore } from '@/stores/SessionStore'

import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals()

export let useOnsiteReportsStore = defineStore('onsiteReportStore', () => {
  const sessionStore = useSessionStore();

  const onsiteReportsData = ref(null);
  const timeStartOffsetMinutes = ref(1440);
  const reportType = ref('human');
  const distanceMiles = ref(19);
  const dayOffset = ref(null);
  const latitude = ref(null);
  const longitude = ref(null);

  const onsiteReports = computed(() => onsiteReportsData.value.onsite_reports || [])
  const hasOnsiteReports = computed(() => onsiteReportsData.value && onsiteReports.value.length > 0)

  async function getOnsiteReports(lat, lon) {
    if (!lat || !lon) return

    latitude.value = lat;
    longitude.value = lon;

    const settings = {
      time_start_offset_minutes: timeStartOffsetMinutes.value,
      report_type: reportType.value,
      distance_mi: distanceMiles.value,
      day_offset: dayOffset.value,     
      lat,
      lon,
      wf_token: sessionStore.token,
    }

    const queryString = new URLSearchParams(settings).toString()
    const url = `${$BASEURL}/report/getOnsiteReportSet?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      onsiteReportsData.value = data.value;

      return data.value;
    } catch (error) {
      console.warn(error)

      return error
    }
  }

  const getSettings = () => ({
    time_start_offset_minutes: timeStartOffsetMinutes.value,
    report_type: reportType.value,
    distance_mi: distanceMiles.value,
    day_offset: dayOffset.value,
    lat: latitude.value,
    lon: longitude.value,
  });

  return {
    onsiteReportsData,
    onsiteReports,
    hasOnsiteReports,
    getOnsiteReports,
    getSettings
  }
})
